<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

       Add Test

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                

               
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Test</label>
                      </div>
                      <div class="col-md-6 padding-right-8px">

                        <!--<CodeTypeValue CodeType="MARTL"
  id="CurrentSaveIvfCycleTestDataRequest.TestName"
  [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestName" SelectedValue=""
  name="CurrentSaveIvfCycleTestDataRequest.TestName" required></CodeTypeValue>-->
                        <!--<input type="text" class="form-control" placeholder="Test"
         id="CurrentSaveIvfCycleTestDataRequest.TestName"
         [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestName"
         name="CurrentSaveIvfCycleTestDataRequest.TestName" #Doctor="ngModel"
         maxlength="100" required>
  <small class="form-text text-danger"
         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
  <small class="form-text text-danger"
         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                        <CustomDataByRequestType RequestedType="IvfFolScanDayTests" ActorCode={{ActorCode}} 
                                                 id="CurrentSaveIvfCycleTestDataRequest.TestCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleTestDataRequest.TestCode" required>
                        </CustomDataByRequestType>

                      </div>

                    </div>

                  </div>
                </div>
                
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Comments </label>
                      </div>
                      <div class="col-md-6 padding-right-8px ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                        
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                  name="CurrentSaveIvfCycleTestDataRequest.Remarks"
                                  [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.Remarks" required minlength="1" maxlength="100"
                                  #addconcerns_text="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                      </div>
                    </div>


                  </div>
                </div>

                


              </div>
            </div>


            

















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
